"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoCardCms = void 0;
var PromoCardCms = /** @class */ (function () {
    function PromoCardCms() {
        this.promoLinkLabel = 'Got a promo code?';
        this.promoRepLinkLabel = 'Got a promo or rep code?';
        this.repLinkLabel = 'Got a rep code?';
        this.enterPromoCodeLabel = 'Enter a promo code (optional)';
        this.applyCtaLabel = 'Apply';
        this.apiErrTxt = "Uh-ho! Something went wrong. Try to add the promo code again.\n     If the problem persist, please try again later.";
        this.enterRepCodeLabel = 'Enter a sales rep code (optional)';
        this.applyRepCtaLabel = 'Apply';
        this.apiRepErrTxt = "Uh-ho! Something went wrong. Try to add the promo code again.\n     If the problem persist, please try again later.";
        this.repCodeTooltip = "If one of our sales representatives stopped by your home, or if you shopped\n     in one of our stores, the sales rep may have given you their rep code. Applying this code will give\n      your rep credit for the sell.";
        this.removeLinkLabel = 'Remove';
        this.repCodeAppliedLabel = 'Sales rep code applied';
        this.apiRepCodeAddErrTxt = "Uh-oh! Something went wrong.\n     Try to add the code again. If the problem persists, please try again later.";
        this.apiRepCodeRemoveErrTxt = "Uh-oh! Something went wrong.\n     Try to remove the code again. If the problem persists, please try again later.";
        this.expiredInvalidPromoCodeErrTxt = "Looks like that code either is invalid or has expired. Make sure you've\n     entered it correctly and try again. (Some codes are case sensitive.)";
        this.promoCodeAlreadyErrTxt = "We've already applied that code to your cart. You're good to go!";
        this.onlyOnePromoCodeErrTxt = "The first promo code you added can't be combined with other promos. You'll\n     have to remove it if you want to add a different one.";
        this.apiPromoCodeRemoveErrTxt = "Uh-oh! Something went wrong.\n    Try to remove the code again. If the problem persists, please try again later.";
        this.incompleteRequestErrTxt = "InComplete Request - Coupon Request Missing";
        this.invalidErrTxt = "Invalid action - Coupon Request has invalid action";
        this.nullEmptyErrTxt = "InComplete Request - Coupon Request has null or empty coupon code";
        this.invalidPromoStack = 'User can not apply more than three coupon.';
        this.promoCodeCheckErrorTxt = 'Looks like that code either is invalid or has expired.' +
            'Certain codes are applicable only for existing AT&T customers.' +
            'If you are an existing AT&T customer, please login and try again.';
        this.couponCodesList = 'SAVEMORE,ABC,DEF';
    }
    return PromoCardCms;
}());
exports.PromoCardCms = PromoCardCms;
//# sourceMappingURL=promoCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/PromoCard/promoCard.cms.js
// module id = 1425
// module chunks = 8